const h3 = require('h3-js');

export const DEFAULT_H3_RESOLUTION = 9;

const toCell = h3.geoToH3 || h3.latLngToCell;
const toGeo = h3.h3ToGeo || h3.cellToLatLng;
const toBoundary = h3.h3ToGeoBoundary || h3.cellToBoundary;

export function latLngToCell(lat, lng, resolution) {
    return toCell(lat, lng, resolution || DEFAULT_H3_RESOLUTION);
}

export function cellCenter(address) {
    const pair = toGeo(address);
    return { lat: pair[0], lng: pair[1] };
}

export function cellLatLngs(address) {
    return toBoundary(address, true).map(pair => [pair[1], pair[0]]);
}

export function pointInGeometry(lng, lat, geometry) {
    if (!geometry || !geometry.type) return false;
    if (geometry.type === 'Polygon') return pointInPolygon(lng, lat, geometry.coordinates);
    if (geometry.type === 'MultiPolygon') {
        return (geometry.coordinates || []).some(polygon => pointInPolygon(lng, lat, polygon));
    }
    return false;
}

function pointInPolygon(lng, lat, coordinates) {
    if (!coordinates || !coordinates.length) return false;
    if (!pointInRing(lng, lat, coordinates[0])) return false;
    for (let i = 1; i < coordinates.length; i += 1) {
        if (pointInRing(lng, lat, coordinates[i])) return false;
    }
    return true;
}

function pointInRing(lng, lat, ring) {
    let inside = false;
    for (let i = 0, j = ring.length - 1; i < ring.length; j = i, i += 1) {
        const xi = ring[i][0];
        const yi = ring[i][1];
        const xj = ring[j][0];
        const yj = ring[j][1];
        const intersect = ((yi > lat) !== (yj > lat))
            && (lng < (((xj - xi) * (lat - yi)) / ((yj - yi) || Number.EPSILON)) + xi);
        if (intersect) inside = !inside;
    }
    return inside;
}



// WEBPACK FOOTER //
// ./app/components/Congestion/h3Selection.js